import { put, takeLatest } from 'redux-saga/effects';
import sagaFetch from './SagaFetch';

import {
  GET_ME_REQUEST,
  GET_ME_SUCCESS,
  GET_ME_PRODUCTS_REQUEST,
  GET_ME_PRODUCTS_SUCCESS,
} from '../constants/action-types';

import * as api from '../services/meApi';
import { requestMyCompany } from '../actions';

function* fetchMe() {
  const { response, error } = yield sagaFetch(api.fetchMeApi);

  if (!error) {
    yield put({ type: GET_ME_SUCCESS, response: response.data });
  }
}

function* handleMeSuccess() {
  yield put(requestMyCompany());
}

function* fetchMeProducts() {
  const { response, error } = yield sagaFetch(api.fetchMeProductsApi);

  if (!error) {
    yield put({ type: GET_ME_PRODUCTS_SUCCESS, response: response.data });
  }
}

export function* meActionWatcher() {
  yield takeLatest(GET_ME_REQUEST, fetchMe);
  yield takeLatest(GET_ME_PRODUCTS_REQUEST, fetchMeProducts);
  yield takeLatest(GET_ME_SUCCESS, handleMeSuccess);
}
